/**
 * FDS 블로킹 원인
 * 참고) AML, CDD 관련 문서 : https://oss.fin.navercorp.com/point-benefit-fe/paylater-web/wiki/%ED%9B%84%EB%B6%88%EA%B2%B0%EC%A0%9C-%EC%9A%A9%EC%96%B4-%EC%84%A4%EB%AA%85
 * */
export const FDS_BLOCK_REASON = {
    /** AML EDD 아이디 결제불가 */
    UNABLE_TO_PAYMENT_FOR_AML_EDD: 'BLK001',
    /** AML CDD 아이디 결제불가 */
    UNABLE_TO_PAYMENT_FOR_AML_CDD: 'BLK002',
    /** FDS 개인정보 노출자 아이디 결제불가 */
    UNABLE_TO_PAYMENT_FOR_PRIVACY_EXPOSURE: 'BLK003',
    /** FDS 거래대상 아이디 결제불가 */
    UNABLE_TO_PAYMENT_FOR_TRANSACTION_TARGET: 'BLK004',
    /** FDS 본인 아이디 결제불가 */
    UNABLE_TO_PAYMENT_FOR_SELF_ID: 'BLK005',
    /** 채권 압류 아이디 결제불가 */
    UNABLE_TO_PAYMENT_FOR_SEIZURE_OF_BOND: 'BLK006',
    /** 알수없는 type */
    UNKNOWN: 'null',
} as const

export type FDSBlockReasonValues = Constant<typeof FDS_BLOCK_REASON>
